import { Main } from './components';

const LegacyDashboard = () => <Main />;

export default LegacyDashboard;
